import { type UseQueryResult, useQuery } from 'react-query';
import {
  DrsToStreetNameTransferService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto,
} from '../../services/wealthlane-award-services';

const useGetDrsToStreetNameList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_DrsToStreetNameTransfer_DrsTransactionDto[] | undefined,
  unknown
> => {
  const drsToStreetNameList = useQuery(
    ['getDrsToStreetNameList'],
    async () => {
      return await handleRequest(
        DrsToStreetNameTransferService.getApiAwardApiAppDrsToStreetNameTransferTransactionsForDrsToStreetNameTransfer(
          ''
        )
      );
    }
    // {
    //   enabled: type === 'RSU',
    // }
  );

  return drsToStreetNameList;
};

export default useGetDrsToStreetNameList;
